import React, { useContext } from 'react';
import { Col, Row, Placeholder } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import './whatWeOfferPlaceholder.scss';

const WhatWeOfferPlaceholder = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const tileArray = [];

  for (let i = 0; i < 4; i += 1) {
    tileArray.push(
      <Col xs="12" sm="6" md="3" key={i}>
        {new Array(3).fill('').map((_, index) => (
          <Placeholder
            key={index}
            height={isMobile ? '29.40' : '45.71'}
            type="text"
            className="what-we-offer-placeholder__text-block"
          />
        ))}
      </Col>
    );
  }
  return (
    <div
      className="what-we-offer-placeholder"
      data-testid="what-we-offer-placeholder"
    >
      <Row>
        {tileArray}
      </Row>
    </div>
  );
};

export { WhatWeOfferPlaceholder };